import DocumentService from '@/Modules/Document/DocumentService.js'
import axios from 'axios'

export default class InvoiceDocumentService extends DocumentService {
  static resource = 'invoices'

  static generate = (invoiceId, payload) =>
    axios.post(`/invoices/${invoiceId}/generate`, payload)

  static json = (invoiceId) => axios.get(`/invoices/${invoiceId}/json`)
}
